import styled from 'styled-components'
import {
  communicationContentWrapperCss,
  communicationImageWrapperCss,
  communicationOptionEmojiCss,
  communicationOptionLabelCss,
  communicationRootCss,
  communicationSubtitleCss,
  communicationTitleCss,
  communicationTitleGroupCss,
} from '~/pages/communication/libs/communicationBaseStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const CommunicationSingleSelectStyles = {
  Root: styled.div`
    ${communicationRootCss}
  `,

  ContentWrapper: styled.div`
    ${communicationContentWrapperCss}
  `,

  TitleGroup: styled.div`
    ${communicationTitleGroupCss}
  `,

  Title: styled.h1`
    ${communicationTitleCss}
  `,

  Subtitle: styled.p`
    ${communicationSubtitleCss}
  `,

  ImageWrapper: styled.div`
    ${communicationImageWrapperCss}
  `,

  Options: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: auto;
  `,

  OptionButton: styled.button<{ $isSelected?: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 20px 16px;
    background: ${COLORS.WHITE};
    border: 2px solid
      ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#eaeaed')};
    border-radius: 16px;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;

    &:active {
      background: ${COLORS.WHITE};
    }

    &:disabled {
      cursor: default;
    }
  `,

  OptionEmoji: styled.span`
    ${communicationOptionEmojiCss}
  `,

  OptionLabel: styled.span`
    ${communicationOptionLabelCss}
  `,
}
